import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import SEO from "@/components/SEO";
import Footer from "@/components/Footer";

const ClassesSection = lazy(() => import("@/components/ClassesSection"));
const TrainersSection = lazy(() => import("@/components/TrainersSection"));
const PricingSection = lazy(() => import("@/components/PricingSection"));
const ShopSection = lazy(() => import("@/components/ShopSection"));
const ReelsSection = lazy(() => import("@/components/ReelsSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const ChatWidget = lazy(() => import("@/components/ChatWidget"));

const SectionFallback = () => (
  <div className="min-h-[200px] flex items-center justify-center">
    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary" />
  </div>
);

const Index = () => {
  return (
    <>
      <SEO
        title="VIP Fitness Club — Premium Gym in Vientiane"
        description="Premium gym in Vientiane, Laos. Group classes, expert personal trainers, modern equipment, and flexible memberships. Open daily 7am–9pm."
        path="/"
      />
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <Suspense fallback={<SectionFallback />}>
          <ClassesSection />
          <TrainersSection />
          <PricingSection />
          <ShopSection />
          <ReelsSection />
          <ContactSection />
        </Suspense>
      </main>
      <Footer />
      <Suspense fallback={null}>
        <ChatWidget />
      </Suspense>
    </div>
    </>
  );
};

export default Index;
